module.exports = __webpack_public_path__ + "static/media/affiliate.1953d663.svg";